import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/shadcn/card';

export default function SuperAdminDashboard() {
  return (
    <div className="space-y-6">
      <div className="block lg:hidden">
        <h1 className="text-xl font-bold">Dashboard Super Admin</h1>
        <p className="text-sm text-muted-foreground">Kelola platform Sporto</p>
      </div>
      <div className="hidden lg:block">
        <h1 className="text-2xl font-bold">Dashboard Super Admin</h1>
        <p className="text-muted-foreground">Kelola platform Sporto</p>
      </div>
      <div className="grid gap-4 md:grid-cols-3">
        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Arena</CardTitle>
            <CardDescription>Kelola arena mitra</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-3xl font-bold text-primary">—</p>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Banner</CardTitle>
            <CardDescription>Kelola banner homepage</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-3xl font-bold text-primary">—</p>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Kategori Olahraga</CardTitle>
            <CardDescription>Kelola kategori sport</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-3xl font-bold text-primary">—</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
